module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-SemiBoldItalic-WebM-f6c2e438b12f616a5b9def6c0e0d359a.woff2";